import { render, staticRenderFns } from "./shopDataToday.vue?vue&type=template&id=aa289e88&scoped=true"
import script from "./shopDataToday.vue?vue&type=script&lang=js"
export * from "./shopDataToday.vue?vue&type=script&lang=js"
import style0 from "./shopDataToday.vue?vue&type=style&index=0&id=aa289e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa289e88",
  null
  
)

export default component.exports